/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $HirerBasicInfo = {
  properties: {
    id: {
      type: 'string',
      isRequired: true,
    },
    name: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
